export const feilfyllingSporsmalsflyt = {
    sporsmal: [
        {
            index: 0,
            id: 'BilQ01',
            tekst: 'Har du BilPluss-forsikring hos oss er du dekket for feilfylling',
            type: 'Radio',
            alternativer: [
                {
                    id: 'BilA01_01',
                    tekst: 'Ja, jeg har BilPluss-forsikring',
                    order: 0,
                },
                {
                    id: 'BilA01_02',
                    tekst: 'Nei, jeg har ikke BilPluss-forsikring',
                    order: 1,
                },
            ],
            gyldigSvarkode: 'BilA01_01',
        },
        {
            index: 1,
            id: 'Forsikringsnummer',
            tekst: 'Hva er forsikringsnummeret?',
            type: 'Tekst',
        },
    ],
};
